import type { RuleSetOutcome } from '@kkp-fraud/shared';
import { t } from '../i18n';
import { DecisionChip } from './Chips';

/**
 * 2c rule sets — each evaluated set's own outcome (`rule_sets` on a decision, only with two or
 * more sets). The final decision is the strongest of these.
 */
export function RuleSetOutcomes({ outcomes, testid = 'rule-sets' }: { outcomes: readonly RuleSetOutcome[] | undefined; testid?: string }) {
  if (!outcomes || outcomes.length === 0) return null;
  return (
    <section className="card" data-testid={testid}>
      <header className="card-head">
        <h2>{t('rulesets.outcomes.title', { n: outcomes.length })}</h2>
      </header>
      <div className="tbl-wrap">
        <table>
          <thead>
            <tr>
              <th>{t('rulesets.col.set')}</th>
              <th style={{ width: 110 }}>{t('rulesets.col.version')}</th>
              <th style={{ width: 140 }}>{t('col.decision.label')}</th>
            </tr>
          </thead>
          <tbody>
            {outcomes.map((o) => (
              <tr key={o.id} data-testid={`${testid}-${o.id}`}>
                <td className="mono">{o.id}</td>
                <td className="mono">{o.version}</td>
                <td>
                  <DecisionChip decision={o.decision} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

/** A hit's rule id with its set when it carries one: `RB-01` · `cnp-risk/RB-01`. */
export function hitKey(h: { rule_id: string; rule_set_id?: string }): string {
  return h.rule_set_id ? `${h.rule_set_id}/${h.rule_id}` : h.rule_id;
}
